import { render } from "./BaseParent.vue?vue&type=template&id=9e1eedea"
import script from "./BaseParent.vue?vue&type=script&lang=js"
export * from "./BaseParent.vue?vue&type=script&lang=js"

import exportComponent from "/src/Hikarusa.Webapp/client-app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__